import { render } from "./StillAdding.vue?vue&type=template&id=0f28a1f5&scoped=true"
import script from "./StillAdding.vue?vue&type=script&lang=js"
export * from "./StillAdding.vue?vue&type=script&lang=js"

import "./StillAdding.vue?vue&type=style&index=0&id=0f28a1f5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f28a1f5"]])

export default __exports__